import * as Yup from 'yup';
import { DocumentType } from '../../../redux/api/documentAttachments/documentAttachment.model';

export interface EditDocumentFormikValues {
  name: string;
  type?: string | null;
  driver_id?: string | null;
  equipment_id?: string | null;
  visibility?: string;
  trip_id?: string | null;
  order_id?: string | null;
  expense_id?: string | null;
  reviewed?: boolean;
}

const documentTypes = Object.values(DocumentType);
const documentTypesString = documentTypes.join('|');

const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const EditDocumentSchema = Yup.object().shape({
  name: Yup.string().required('You must enter a name'),
  type: Yup.string()
    .optional()
    .nullable()
    .matches(new RegExp(`^(${documentTypesString})$`), 'Invalid type'),
  visibility: Yup.string()
    .optional()
    .nullable()
    .matches(/^(visible|hidden)$/, 'Invalid visibility'),
  driver_id: Yup.string().optional().nullable().matches(uuidRegex, 'Invalid driver id'),
  equipment_id: Yup.string().optional().nullable().matches(uuidRegex, 'Invalid equipment id'),
  trip_id: Yup.string().optional().nullable().matches(uuidRegex, 'Invalid trip id'),
  order_id: Yup.string().optional().nullable().matches(uuidRegex, 'Invalid order id'),
  expense_id: Yup.string().optional().nullable().matches(uuidRegex, 'Invalid expense id')
});

/**
 * Function to validate form fields, returns a promise with the error message or null
 * This function is used to validate the form fields when the user submits the form
 * this in order to display one error at a time in notification bar
 *
 * @param values
 * @returns
 */
export const validateErrors = async (
  values: EditDocumentFormikValues,
  setErrors: (errors: any) => void
): Promise<string | null> => {
  try {
    await EditDocumentSchema.validate(values, { abortEarly: false });
    return null;
  } catch (err: any) {
    const firstError = {
      [err.inner[0].path]: err.inner[0].message
    };
    setErrors(firstError);
    return err.inner[0].message;
  }
};
